// extracted by mini-css-extract-plugin
export default {"box":"Loading_box__-uJFk","coin":"Loading_coin__HtE8y","spin":"Loading_spin__sCrfu"};